import type { RootState } from '@app/store';
import { createSelector } from '@reduxjs/toolkit';

export const selectEngagementTasks = createSelector(
  [
    (state: RootState) => state.engagement.tasks,
  ],
  (tasks) => [ ...tasks ].sort((a, b) => a.position - b.position),
);
export const selectHasEngagementTasks = (state: RootState) => {
  return state.engagement.tasks.length > 0;
};
